import { render, staticRenderFns } from "./NmtSidebarProfileStat.vue?vue&type=template&id=6b9c2185&scoped=true&"
import script from "./NmtSidebarProfileStat.vue?vue&type=script&lang=js&"
export * from "./NmtSidebarProfileStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9c2185",
  null
  
)

export default component.exports